import * as React from "react";
import TrackerContext from "./Context";
export const useTracker = () => React.useContext(TrackerContext);
/**
 * @deprecated since version 1.0.0
 */

export const useTrackerContext = useTracker;